module.exports = __webpack_public_path__ + "img/PP通风柜.b97c584f.jpg";